import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import UserForm from "./profile";
import { SETTINGS } from "../strings";
import {
  updateUserById,
  updateUserFromProfileSettings
} from "../../services/api-declaration";
import { showError, showSuccess } from "../../services/toast-service";
import { useTranslation } from "react-i18next";

const UserFormPage = ({ forProfileSettings = false }) => {
  const { t } = useTranslation();
  const userId = useParams().id;
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const [isSettingsProfileActive, setIsSettingsProfileActive] = useState(false);
  const splittedPath = location.pathname.split("/");
  const tabName = splittedPath[splittedPath.length - 1];

  useEffect(() => {
    if (tabName.toUpperCase() === SETTINGS.PROFILE) {
      setIsSettingsProfileActive(true);
    } else {
      setIsSettingsProfileActive(false);
    }
  }, [tabName]);

  const handleUpdate = async (formValues) => {
    try {
      const data = { ...formValues };
      if (isSettingsProfileActive) {
        // update me for marketing manager
        await updateUserFromProfileSettings(data);
      } else {
        // update any user by any admin
        await updateUserById(data, userId);
      }
      showSuccess(data.message || "User updated successfully!");
    } catch (error) {
      showError(
        error?.response?.data?.message || t("toastMessage.updateUserError")
      );
    }
  };
  return (
    <>
      {forProfileSettings && <h5 className="my-4">Profile</h5>}
      <UserForm
        userId={isSettingsProfileActive ? user._id : userId}
        handleFormSubmit={handleUpdate}
        forProfileSettings={forProfileSettings}
      />
    </>
  );
};

export default UserFormPage;
